import { NetworkConfiguration } from "../../network/networkConfriguation";
import { callAPI } from "../../network/networkConnection";

const AddUpdateCart = (productPayload) => {
  return new Promise((resolve, reject) => {
    callAPI(
      process.env.REACT_APP_APIUrl + NetworkConfiguration.ADD_TO_CART,
      "POST",
      {
        "Content-Type": "application/json",
      },
      productPayload
    )
      .then((res) => {
        resolve(res);
      })
      .catch((err) => {
        reject(err);
      });
  });
};

const RemoveFromCart = (productPayload) => {
  return new Promise((resolve, reject) => {
    callAPI(
      process.env.REACT_APP_APIUrl + NetworkConfiguration.REMOVE_FROM_CART,
      "POST",
      {
        "Content-Type": "application/json",
      },
      productPayload
    )
      .then((res) => {
        resolve(res);
      })
      .catch((err) => {
        reject(err);
      });
  });
};

const RemoveAllCart = () => {
  return new Promise((resolve, reject) => {
    callAPI(
      process.env.REACT_APP_APIUrl + NetworkConfiguration.REMOVE_ALL_CART,
      "GET",
      {
        "Content-Type": "application/json",
      },
    )
      .then((res) => {
        resolve(res);
      })
      .catch((err) => {
        reject(err);
      });
  });
};

const getCartCount = () => {
  return new Promise((resolve, reject) => {
    callAPI(
      process.env.REACT_APP_APIUrl + NetworkConfiguration.GET_CART_COUNT,
      "GET",
      {
        "Content-Type": "application/json",
      },
    )
      .then((res) => {
        resolve(res);
      })
      .catch((err) => {
        reject(err);
      });
  });
};

const getCart = () => {
  return new Promise((resolve, reject) => {
    callAPI(
      process.env.REACT_APP_APIUrl + NetworkConfiguration.GET_CART,
      "GET",
      {
        "Content-Type": "application/json",
      },
    )
      .then((res) => {
        resolve(res);
      })
      .catch((err) => {
        reject(err);
      });
  });
};

const paymentConfirm = (addressPayload) => {
  return new Promise((resolve, reject) => {
    callAPI(
      process.env.REACT_APP_APIUrl + NetworkConfiguration.PAYMENT_CONFIRM,
      "POST",
      {
        "Content-Type": "application/json",
      },
      addressPayload
    )
      .then((res) => {
        resolve(res);
      })
      .catch((err) => {
        reject(err);
      });
  });
};

const paymentVerify = (payload) => {
  return new Promise((resolve, reject) => {
    callAPI(
      process.env.REACT_APP_APIUrl + NetworkConfiguration.PAYMENT_VERIFY,
      "POST",
      {
        "Content-Type": "application/json",
      },
      payload
    )
      .then((res) => {
        resolve(res);
      })
      .catch((err) => {
        reject(err);
      });
  });
};

const razorpayStatus = (queryString) => {
  return new Promise((resolve, reject) => {
    callAPI(
      process.env.REACT_APP_APIUrl + NetworkConfiguration.RAZORPAY_STATUS + (queryString || ""),
      "GET",
      {
        "Content-Type": "application/json",
      }
    )
      .then((res) => resolve(res))
      .catch((err) => reject(err));
  });
};

const bankTransferSettings = () => {
  return new Promise((resolve, reject) => {
    callAPI(
      process.env.REACT_APP_APIUrl + NetworkConfiguration.BANK_TRANSFER_SETTINGS,
      "GET",
      { "Content-Type": "application/json" }
    )
      .then((res) => resolve(res))
      .catch((err) => reject(err));
  });
};

/** Best-effort analytics: never reject — checkout must not depend on lead recording. */
const recordAbandonedLead = (payload) => {
  return new Promise((resolve) => {
    let body;
    try {
      body = JSON.stringify(payload ?? {});
    } catch {
      resolve({ status: { code: 0 }, data: null, skipped: true });
      return;
    }
    callAPI(
      process.env.REACT_APP_APIUrl + NetworkConfiguration.ABANDONED_LEAD,
      "POST",
      { "Content-Type": "application/json" },
      body
    )
      .then((res) => resolve(res))
      .catch(() => resolve({ status: { code: 0 }, data: null, skipped: true }));
  });
};

const bankTransferPlaceOrder = (payload) => {
  return new Promise((resolve, reject) => {
    callAPI(
      process.env.REACT_APP_APIUrl + NetworkConfiguration.BANK_TRANSFER_PLACE_ORDER,
      "POST",
      { "Content-Type": "application/json" },
      JSON.stringify(payload)
    )
      .then((res) => resolve(res))
      .catch((err) => reject(err));
  });
};

const ccavenueInitiate = (payload) => {
  return new Promise((resolve, reject) => {
    callAPI(
      process.env.REACT_APP_APIUrl + NetworkConfiguration.CCAVENUE_INITIATE,
      "POST",
      { "Content-Type": "application/json" },
      JSON.stringify(payload)
    )
      .then((res) => resolve(res))
      .catch((err) => reject(err));
  });
};

const ccavenueStatus = (orderId) => {
  return new Promise((resolve, reject) => {
    callAPI(
      process.env.REACT_APP_APIUrl + NetworkConfiguration.CCAVENUE_STATUS + orderId,
      "GET",
      { "Content-Type": "application/json" }
    )
      .then((res) => resolve(res))
      .catch((err) => reject(err));
  });
};

export const CartApiService = {
  AddUpdateCart,
  RemoveFromCart,
  RemoveAllCart,
  getCartCount,
  getCart,
  paymentConfirm,
  paymentVerify,
  razorpayStatus,
  bankTransferSettings,
  recordAbandonedLead,
  bankTransferPlaceOrder,
  ccavenueInitiate,
  ccavenueStatus,
};
